export const enum DateFormat {
    YYYY_MM_DD = 'YYYY-MM-DD',
    MM_DD_YYYY = 'MM-DD-YYYY',
} 

export const TODAY_VALUE = 'today';
export const YESTERDAY_VALUE = 'yesterday';
export const LAST_7_DAYS_VALUE = 'last7Days';
export const LAST_60_DAYS_VALUE = 'last60Days';
export const CUSTOM_VALUE = 'custom';

export const DATE_SELECTION_OPTIONS = [
    { label: 'Today', value: TODAY_VALUE },
    { label: 'Yesterday', value: YESTERDAY_VALUE },
    { label: 'Last 7 Days', value: LAST_7_DAYS_VALUE },
    { label: 'Last 60 Days', value: LAST_60_DAYS_VALUE },
    { label: 'Custom', value: CUSTOM_VALUE },
];

export const IANA_TIMEZONE_CANONICAL_MAP: Record<string, string> = {
    // Asia
    'Asia/Calcutta': 'Asia/Kolkata',
    'Asia/Chongqing': 'Asia/Shanghai',
    'Asia/Chungking': 'Asia/Shanghai',
    'Asia/Dacca': 'Asia/Dhaka',
    'Asia/Harbin': 'Asia/Shanghai',
    'Asia/Istanbul': 'Europe/Istanbul',
    'Asia/Kashgar': 'Asia/Urumqi',
    'Asia/Katmandu': 'Asia/Kathmandu',
    'Asia/Macao': 'Asia/Macau',
    'Asia/Rangoon': 'Asia/Yangon',
    'Asia/Saigon': 'Asia/Ho_Chi_Minh',
    'Asia/Tel_Aviv': 'Asia/Jerusalem',
    'Asia/Thimbu': 'Asia/Thimphu',
    'Asia/Ujung_Pandang': 'Asia/Makassar',
    'Asia/Ulan_Bator': 'Asia/Ulaanbaatar',
    
    // Atlantic
    'Atlantic/Faeroe': 'Atlantic/Faroe',
    'Atlantic/Jan_Mayen': 'Europe/Oslo',
    
    // Australia
    'Australia/ACT': 'Australia/Sydney',
    'Australia/Canberra': 'Australia/Sydney',
    'Australia/LHI': 'Australia/Lord_Howe',
    'Australia/North': 'Australia/Darwin',
    'Australia/NSW': 'Australia/Sydney',
    'Australia/Queensland': 'Australia/Brisbane',
    'Australia/South': 'Australia/Adelaide',
    'Australia/Tasmania': 'Australia/Hobart',
    'Australia/Victoria': 'Australia/Melbourne',
    'Australia/West': 'Australia/Perth',
    'Australia/Yancowinna': 'Australia/Broken_Hill',
    
    // Europe
    'Europe/Belfast': 'Europe/London',
    'Europe/Tiraspol': 'Europe/Chisinau',
    
    // Pacific
    'Pacific/Johnston': 'Pacific/Honolulu',
    'Pacific/Midway': 'Pacific/Pago_Pago',
    'Pacific/Samoa': 'Pacific/Pago_Pago',
    'Pacific/Yap': 'Pacific/Port_Moresby',
    
    // America (if any deprecated ones exist)
    'America/Atka': 'America/Adak',
    'America/Buenos_Aires': 'America/Argentina/Buenos_Aires',
    'America/Catamarca': 'America/Argentina/Catamarca',
    'America/Cordoba': 'America/Argentina/Cordoba',
    'America/Ensenada': 'America/Tijuana',
    'America/Fort_Wayne': 'America/Indiana/Indianapolis',
    'America/Indianapolis': 'America/Indiana/Indianapolis',
    'America/Jujuy': 'America/Argentina/Jujuy',
    'America/Knox_IN': 'America/Indiana/Knox',
    'America/Louisville': 'America/Kentucky/Louisville',
    'America/Mendoza': 'America/Argentina/Mendoza',
    'America/Montreal': 'America/Toronto',
    'America/Porto_Acre': 'America/Rio_Branco',
    'America/Rosario': 'America/Argentina/Cordoba',
    'America/Santa_Isabel': 'America/Tijuana',
    'America/Shiprock': 'America/Denver',
    'America/Virgin': 'America/Port_of_Spain',
};